namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.AutomaticReports.MonitorAlertDialog')
    export class MonitorAlertDialog extends Serenity.EntityDialog<MonitorAlertRow, any> {
        protected getFormKey() { return MonitorAlertForm.formKey; }
        protected getIdProperty() { return MonitorAlertRow.idProperty; }
        protected getLocalTextPrefix() { return MonitorAlertRow.localTextPrefix; }
        protected getNameProperty() { return MonitorAlertRow.nameProperty; }
        protected getService() { return MonitorAlertService.baseUrl; }
        protected getDeletePermission() { return MonitorAlertRow.deletePermission; }
        protected getInsertPermission() { return MonitorAlertRow.insertPermission; }
        protected getUpdatePermission() { return MonitorAlertRow.updatePermission; }

        protected form = new MonitorAlertForm(this.idPrefix);
    }
}